// extracted by mini-css-extract-plugin
export var container = "AirportTourList-module--container--1vpAQ";
export var tourItem = "AirportTourList-module--tourItem--1IZk1";
export var image = "AirportTourList-module--image--3vUSv";
export var card = "AirportTourList-module--card--17RrY";
export var category = "AirportTourList-module--category--3ZPmY";
export var title = "AirportTourList-module--title--NwbeW";
export var price = "AirportTourList-module--price--1TVPd";